import { useState,useEffect } from "react"
import {useParams, useNavigate} from "react-router-dom"
import {useDispatch,useSelector} from 'react-redux'
import NavBar from "../components/NavBar"
import { fetchMovieDetail } from "../store/actions"
import CastCard from "../components/CastCard"

export default function DetailPage(){
    const navigate= useNavigate()
    const dispatch= useDispatch()
    const{id}= useParams()
    const {detailMovies}= useSelector((state)=>state.movie)
    useEffect(()=>{
      dispatch(fetchMovieDetail(id))
    },[])
    const buttonBack= ()=>{
        navigate('/')
    }
    return(
        <div >
            <div className="bg-gray-900 max-w-max bg-fixed">
            <NavBar/>
            <div className="justify-center items-center flex text-center pt-5 pb-10">
            <div className="bg-blue-900 rounded-lg h-auto pb-10" style={{width:"1300px"}}>
            <div className="justify-center items-center flex text-center">
                <iframe src={detailMovies.trailerUrl} style={{width:"1400px", height: "500px"}} title="W3Schools Free Online Web Tutorials"></iframe>
                </div>
                <div className="justify-start items-center flex text-center pt-5 pl-5 absolute">
                <img src={detailMovies.imgUrl} alt="" style={{width:"180px",height:"260px"}}/>
                </div>
                <div className=" text-start pl-56 pt-1 text-white">
                <h1 style={{fontSize: "30pt"}}>{detailMovies.title}</h1>
                </div>
                <div className=" text-start pl-56 text-white">
                <h1>Synopsis:</h1>
                <h1 >{detailMovies.synopsis}</h1>
                </div>
                <div className=" text-start text-white pl-56">
                <h1 >Genre:</h1>
                <h1>{detailMovies?.Genre?.name}</h1>
                </div>
                <div className=" text-start text-white pl-56">
                <h1 >Rating:</h1>
                <div className="bg-yellow-400 text-black absolute text-center rounded-lg text-xl pt-0.5" style={{width:"30px", height: "30px"}}>
                <h1 >{detailMovies.rating}</h1>
                </div>
                </div>
                <div className=" text-end pr-10 text-white pt-9 ">
                    <button onClick={buttonBack} className="bg-red-400 rounded-lg" style={{width:"150px",height:"40px"}}>Back</button>
                </div>
                {detailMovies?.Casts?.length == 0 ? "" : <h1 className="absolute pl-10 pt-10 text-white" style={{fontSize: "20pt"}}>CAST</h1>}
                <div className=" text-start justify-start items-start flex text-white pl-10 pt-20">
                    <div className="grid grid-cols-10">
                {detailMovies?.Casts?.map((cast)=>
                    <CastCard key={cast.id} cast={cast}/>
                    )}
                    </div>
                </div>
               
            </div>
            </div>

            </div>
        </div>
    )
}